package com.bikompanion.data.parking

import kotlinx.browser.window
import kotlinx.coroutines.await
import org.khronos.webgl.Int8Array
import org.w3c.fetch.RequestInit
import com.bikompanion.data.logNetwork

/**
 * Served from the app's own origin — Kotlin/JS copies `jsMain/resources` into the bundle — so
 * this is same-origin, needs no CORS, and the browser caches it like any other asset.
 */
internal actual suspend fun loadParkingDatasetBytes(): ByteArray? =
    runCatching {
        val response = window.fetch(ParkingDatasetFileName, js("({})").unsafeCast<RequestInit>()).await()
        if (!response.ok) return null
        val buffer = response.arrayBuffer().await()
        val bytes = Int8Array(buffer).unsafeCast<ByteArray>()
        logNetwork("Parking", "dataset loaded (${bytes.size} bytes)")
        bytes
    }.getOrNull()
